import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Menu, Dropdown, Space, Avatar, Typography } from 'antd';
import {
  DashboardOutlined,
  FileTextOutlined,
  MessageOutlined,
  BarChartOutlined,
  DollarOutlined,
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
  BuildOutlined
} from '@ant-design/icons';
import { logout } from '../../store/authSlice';

const { Header } = Layout;
const { Text } = Typography;

function Navbar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const handleMenuClick = ({ key }) => {
    if (key === 'logout') {
      handleLogout();
    } else if (key === 'settings') {
      navigate('/settings');
    }
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: (
        <div>
          <div style={{ fontWeight: 600 }}>{user?.full_name || 'User'}</div>
          <div style={{ fontSize: '12px', color: '#6B7280' }}>{user?.email}</div>
        </div>
      ),
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'Settings',
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      danger: true,
    },
  ];

  const getInitials = () => {
    if (user?.full_name) {
      const names = user.full_name.split(' ');
      return names.length > 1 
        ? `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase()
        : names[0][0].toUpperCase();
    }
    return user?.email?.[0].toUpperCase() || 'U';
  };

  const navItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: <Link to="/dashboard">Dashboard</Link>,
    },
    {
      key: '/documents',
      icon: <FileTextOutlined />,
      label: <Link to="/documents">Documents</Link>,
    },
    {
      key: '/ask',
      icon: <MessageOutlined />,
      label: <Link to="/ask">Ask Questions</Link>,
    },
    {
      key: '/analytics',
      icon: <BarChartOutlined />,
      label: <Link to="/analytics">Analytics</Link>,
    },
    {
      key: '/billing',
      icon: <DollarOutlined />,
      label: <Link to="/billing">Billing</Link>,
    },
  ];

  return (
    <Header 
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Link 
          to="/dashboard" 
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            marginRight: '40px',
            textDecoration: 'none'
          }}
        >
          <BuildOutlined style={{ fontSize: '24px', color: '#0B3D91', marginRight: '12px' }} />
          <Text 
            strong 
            style={{ 
              fontSize: '18px', 
              color: '#111827',
              letterSpacing: '-0.5px'
            }}
          >
            IndustrialIQ
          </Text>
        </Link>

        <Menu
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={navItems}
          style={{
            flex: 1,
            minWidth: 0,
            border: 'none',
            backgroundColor: 'transparent',
          }}
        />
      </div>

      <Dropdown 
        menu={{ items: userMenuItems, onClick: handleMenuClick }} 
        placement="bottomRight"
        arrow
      >
        <Space style={{ cursor: 'pointer' }}>
          <Avatar 
            style={{ backgroundColor: '#0B3D91', fontWeight: 600 }}
            icon={!user?.full_name && !user?.email && <UserOutlined />}
          >
            {getInitials()}
          </Avatar>
          <span style={{ display: 'none', '@media (min-width: 768px)': { display: 'inline' } }}>
            <Text strong style={{ fontSize: '14px' }}>
              {user?.full_name || user?.email?.split('@')[0] || 'User'}
            </Text>
          </span>
        </Space>
      </Dropdown>
    </Header>
  );
}

export default Navbar;
